import { createFileRoute } from '@tanstack/react-router';
import { useBatchOverview } from '@/lib/hooks/useTrainer';
import { StudentsTab } from '@/features/Trainer/StudentsTab';

export const Route = createFileRoute('/trainer/batches/$batchId/students')({
  component: StudentsRoute,
});

function StudentsRoute() {
  const { batchId } = Route.useParams();
  const { data: overview, isLoading } = useBatchOverview(batchId);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <StudentsTab students={overview?.students ?? []} batchId={batchId} />
    </div>
  );
}
